import React from 'react';
import {
  isChildSelected,
  isSomethingSelected,
} from '../facet_utils';
import CollapsingFacet from './collapsing_facet';
import { SelectFacetOption } from './select_facet_option';
import type { FilterOption, FilterProps } from './search_filters';

export default class NestedSelectFacet extends React.Component<FilterProps, null> {
  renderChildrenFor(option: FilterOption) {
    if (!option.subFilter || !option.subFilter.options) {
      return null;
    }

    const links = option.subFilter.options.map((option, idx) => (
      <SelectFacetOption
        key={idx}
        option={option}
        trackingQuery={this.props.trackingQuery}
      >
        {isChildSelected(option, true) && this.renderChildrenFor(option)}
      </SelectFacetOption>
    ));

    return (
      <CollapsingFacet count={links.length} countThreshold={6}>
        <ul className="facet__options">{links}</ul>
      </CollapsingFacet>
    );
  }

  renderRootLinks() {
    const nothingSelected = !isSomethingSelected(this.props.filter);

    return this.props.filter.options.map((option, idx) => {
      if (option.selected || isChildSelected(option)) {
        return (
          <SelectFacetOption
            key={idx}
            option={option}
            trackingQuery={this.props.trackingQuery}
            childActive
          >
            {this.renderChildrenFor(option)}
          </SelectFacetOption>
        );
      }

      if (nothingSelected || option.all) {
        return <SelectFacetOption
          key={idx}
          option={option}
          trackingQuery={this.props.trackingQuery}
          childActive={option.all}
        />;
      }
    });
  }

  render() {
    if (this.props.filter.options.length === 0) {
      return null;
    }

    return (
      <div className="facet">
        <div className="facet__heading">{this.props.filter.name}</div>
        <ul className="facet__options">{this.renderRootLinks()}</ul>
      </div>
    );
  }
}
